import { css } from 'styled-components/macro';

const sizes: { [key: string]: { [key: string]: number } } = {
    desktop: {
        min: 1600,
    },

    laptop: {
        min: 1048,
        max: 1600,
    },

    fromLaptop: {
        min: 1049,
    },

    toTablet: {
        max: 1048,
    },

    fromTablet: {
        min: 701,
    },

    mobile: {
        max: 700,
    },

    tablet: {
        min: 701,
        max: 1047,
    },
};

// Iterate through the sizes and create a media template
// See https://stackoverflow.com/a/49398439 for typing hints
export const media = Object.keys(sizes).reduce((acc: any, label) => {
    acc[label] = (literals: TemplateStringsArray, ...placeholders: any[]) => {
        const size = sizes[label];
        let query = '@media screen and ';

        if (size.min) {
            query += `(min-width: ${size.min}px)`;
        }

        if (size.min && size.max) {
            query += ' and ';
        }

        if (size.max) {
            query += `(max-width: ${size.max}px)`;
        }
        return css`
            ${query} {
                ${//@ts-ignore
                css(literals, ...placeholders)}
            }
        `;
    };

    return acc;
}, {});

// determine screen size
export const isTabletOrSmaller = () =>
    window && window.innerWidth <= sizes.toTablet.max;

export const isMobile = () => window && window.innerWidth <= sizes.mobile.max;

export const getNavBarHeight = () => {
    const navigationBar = document.getElementById('navigation');
    return navigationBar ? navigationBar.clientHeight : 0;
};

export default media;
